import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  password: yup.string().min(8, 'Must Contain 8 Characters').max(16).matches(
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
    'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character',
  ),
  confirmPassword: yup.string().equalTo(yup.ref('password'), 'Passwords do not match'),
});
